module.exports = __webpack_public_path__ + "img/9-climb_v8e_loading.733af638.jpg";